export default __webpack_public_path__ + "static/media/iconAdd.0188c8d3.svg";